// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"5e549a8e","732":"43791076","977":"d982f279"}[chunkId] + ".chunk.js";
};